import type {
  AllowedApiClientsResponse,
  FetchAllowedApiClientsListParams
} from 'Services/common/Features/AllowedApiClient/types'
import { createBaseApi } from 'Util/ApiClient'
import { RTKCacheTags } from 'Util/constants'

enum TagTypes {
  ALLOWED_API_CLIENT = 'AllowedApiClient',
  SPM_ALLOWED_API_CLIENT = 'SPMAllowedApiClient'
}

export const allowedApiClientApi = createBaseApi({
  reducerPath: 'allowedApiClientApi',
  keepUnusedDataFor: 5,
  tagTypes: [TagTypes.ALLOWED_API_CLIENT, TagTypes.SPM_ALLOWED_API_CLIENT]
}).injectEndpoints({
  endpoints: builder => ({
    getAllowedApiClients: builder.query<
      AllowedApiClientsResponse,
      // biome-ignore lint/suspicious/noConfusingVoidType: RTK query requires void type for no params
      FetchAllowedApiClientsListParams | void
    >({
      query: params => ({
        url: '/api/v1/allowed-api-client/',
        params: params ?? undefined
      }),
      providesTags: [{ type: TagTypes.ALLOWED_API_CLIENT, id: RTKCacheTags.LIST }]
    }),
    getSpmAllowedApiClients: builder.query<
      AllowedApiClientsResponse,
      // biome-ignore lint/suspicious/noConfusingVoidType: RTK query requires void type for no params
      FetchAllowedApiClientsListParams | void
    >({
      query: params => ({
        url: '/api/v1/spm-allowed-api-client/',
        params: params ?? undefined
      }),
      providesTags: [{ type: TagTypes.SPM_ALLOWED_API_CLIENT, id: RTKCacheTags.LIST }]
    })
  })
})

export const { useGetAllowedApiClientsQuery, useGetSpmAllowedApiClientsQuery } = allowedApiClientApi
